import Cookies from "js-cookie";

export const normalizeCountryCode = (value: unknown): string | null => {
  if (typeof value !== "string") return null;
  const country = value.trim().toUpperCase();
  return /^[A-Z]{2}$/.test(country) && country !== "EN" ? country : null;
};

let pendingCountry: Promise<string | null> | null = null;

export const resolveVisitorCountry = async (): Promise<string | null> => {
  const cachedCountry = normalizeCountryCode(Cookies.get("isoCode"));
  if (cachedCountry) return cachedCountry;
  if (pendingCountry) return pendingCountry;

  pendingCountry = (async () => {
    try {
      const response = await fetch("/api/azmaps/ipLocation", {
        cache: "no-store",
        signal: AbortSignal.timeout(10000),
      });
      if (!response.ok) return null;
      const country = normalizeCountryCode(await response.json());
      if (country) Cookies.set("isoCode", country.toLowerCase(), { expires: 365, sameSite: "lax" });
      return country;
    } catch {
      return null;
    }
  })();

  try {
    return await pendingCountry;
  } finally {
    pendingCountry = null;
  }
};